const adminNavigation = [
  { pattern: /^\/admin\/?$/, title: "Administration", trail: [] },
  { pattern: /^\/admin\/user$/, title: "Admin-Benutzer", trail: [] },
  { pattern: /^\/admin\/user_detail\/[^/]+$/, title: "Benutzer-Details", trail: [{ title: "Admin-Benutzer", path: "/admin/user" }] },
  { pattern: /^\/admin\/team\/users$/, title: "Team-Logins", trail: [] },
  { pattern: /^\/admin\/team\/pending$/, title: "Spieler-Berechtigungen", trail: [{ title: "Spieler", path: "/admin/players" }] },
  { pattern: /^\/admin\/team$/, title: "Mannschaften", trail: [] },
  { pattern: /^\/admin\/team_detail\/[^/]+$/, title: "Mannschafts-Details", trail: [{ title: "Mannschaften", path: "/admin/team" }] },
  { pattern: /^\/admin\/players$/, title: "Spieler", trail: [] },
  { pattern: /^\/admin\/players_detail\/[^/]+$/, title: "Spieler-Details", trail: [{ title: "Spieler", path: "/admin/players" }] },
  { pattern: /^\/admin\/referee$/, title: "Schiedsrichter", trail: [] },
  { pattern: /^\/admin\/referee_detail\/[^/]+$/, title: "Schiedsrichter-Details", trail: [{ title: "Schiedsrichter", path: "/admin/referee" }] },
  { pattern: /^\/admin\/league$/, title: "Ligen", trail: [] },
  { pattern: /^\/admin\/league_detail\/[^/]+$/, title: "Liga-Details", trail: [{ title: "Ligen", path: "/admin/league" }] },
  { pattern: /^\/admin\/season_detail\/[^/]+$/, title: "Saison-Details", trail: [{ title: "Ligen", path: "/admin/league" }] },
  { pattern: /^\/admin\/match_detail\/[^/]+$/, title: "Spiel-Details", trail: [{ title: "Ligen", path: "/admin/league" }] },
  { pattern: /^\/admin\/stadiums$/, title: "Stadien", trail: [{ title: "Ligen", path: "/admin/league" }] },
  { pattern: /^\/admin\/stadium_detail\/[^/]+$/, title: "Stadion-Details", trail: [{ title: "Ligen", path: "/admin/league" }, { title: "Stadien", path: "/admin/stadiums" }] },
  { pattern: /^\/admin\/registrations$/, title: "Registrierungen", trail: [] },
  { pattern: /^\/admin\/registration_detail\/[^/]+$/, title: "Registrierungs-Details", trail: [{ title: "Registrierungen", path: "/admin/registrations" }] },
  { pattern: /^\/admin\/strafsenat$/, title: "Strafsenat", trail: [] },
  { pattern: /^\/admin\/strafsenat\/detail\/[^/]+$/, title: "Strafsenat-Details", trail: [{ title: "Strafsenat", path: "/admin/strafsenat" }] },
  { pattern: /^\/admin\/news$/, title: "News", trail: [] },
  { pattern: /^\/admin\/news_detail\/[^/]+$/, title: "News-Details", trail: [{ title: "News", path: "/admin/news" }] },
  { pattern: /^\/admin\/news_strafsenat$/, title: "Strafsenat-News", trail: [] },
  { pattern: /^\/admin\/news_strafsenat_detail\/[^/]+$/, title: "Strafsenat-News-Details", trail: [{ title: "Strafsenat-News", path: "/admin/news_strafsenat" }] },
  { pattern: /^\/admin\/people-events$/, title: "Veranstaltungen", trail: [] },
  { pattern: /^\/admin\/people-events\/[^/]+$/, title: "Veranstaltungs-Details", trail: [{ title: "Veranstaltungen", path: "/admin/people-events" }] },
  { pattern: /^\/admin\/fees$/, title: "Gebühren & Beträge", trail: [] },
  { pattern: /^\/admin\/rechnungen$/, title: "Rechnungen", trail: [] },
  { pattern: /^\/admin\/rechnung_erstellung$/, title: "Rechnung erstellen", trail: [{ title: "Rechnungen", path: "/admin/rechnungen" }] },
  { pattern: /^\/admin\/transfers$/, title: "Transfers", trail: [] },
  { pattern: /^\/admin\/transfer_settings$/, title: "Transfer-Einstellungen", trail: [{ title: "Transfers", path: "/admin/transfers" }] },
  { pattern: /^\/admin\/postpone$/, title: "Spielverlegungen", trail: [] },
  { pattern: /^\/admin\/chat$/, title: "Posteingang", trail: [] },
  { pattern: /^\/admin\/push-notifications$/, title: "Push-Mitteilungen", trail: [] },
  { pattern: /^\/admin\/legal$/, title: "Rechtliches", trail: [] },
  { pattern: /^\/admin\/homepage-analytics$/, title: "Homepage Analytics", trail: [] },
  { pattern: /^\/admin\/email-templates$/, title: "E-Mail Notifier", trail: [] },
  { pattern: /^\/admin\/homepage-content$/, title: "Homepage-Inhalte", trail: [] },
  { pattern: /^\/admin\/sponsors$/, title: "Sponsoren", trail: [] },
];

export function getAdminNavigation(pathname) {
  return adminNavigation.find(({ pattern }) => pattern.test(pathname)) || {
    title: "Administration",
    trail: [],
  };
}

export function getAdminBreadcrumbs(pathname, detailTitle, navigationTrail) {
  const current = getAdminNavigation(pathname);
  const title = detailTitle || current.title;
  return [
    { title: "Administration", path: "/admin" },
    ...(navigationTrail || current.trail),
    ...(pathname === "/admin" || pathname === "/admin/" ? [] : [{ title }]),
  ];
}

export default adminNavigation;
